<template>
  <el-menu mode="vertical" unique-opened theme="dark" :default-active="$route.path" :collapse="isCollapse" background-color="#D4DBE3" text-color="#000000" active-text-color="#409EFF">
    <sidebar-item :routes='permissionMenus'></sidebar-item>
    <!-- <sidebar-item :routes='menus'></sidebar-item> -->
  </el-menu>
</template>


<script>
import { mapGetters } from 'vuex';
import SidebarItem from './SidebarItem';
export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'sidebar',
      'permissionMenus'
    ]),
    isCollapse () {
      return !this.sidebar.opened
    }
  },
  data () {
    return {
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/layout/Sidebar.vue